import gql from 'graphql-tag';

const CREATE_NEW_WORKLOG = gql`
  mutation(
    $ticketId: ID
    $taskId: ID
    $projectId: ID
    $worklog: WorklogInput!
  ) {
    createWorklog(
      ticketId: $ticketId
      taskId: $taskId
      projectId: $projectId
      input: $worklog
    ) {
      worklogId
      technician {
        name
        userId
      }
      notes
      createdTime
      worklogItems {
        itemId
        serviceItem {
          name
          quantityType
          itemId
        }
        billable
        qty
      }
    }
  }
`;

const UPDATE_WORKLOG = gql`
  mutation($worklogId: ID!, $worklog: WorklogInput!) {
    updateWorklog(worklogId: $worklogId, input: $worklog) {
      worklogId
      technician {
        name
        userId
      }
      notes
      createdTime
      worklogItems {
        itemId
        serviceItem {
          name
          quantityType
          itemId
        }
        billable
        afterHours
        qty
      }
    }
  }
`;

const CREATE_NEW_WORKLOG_TIMER = gql`
  mutation($ticketId: ID, $projectId: ID, $worklogTimer: WorklogTimerInput!) {
    createWorklogTimer(
      ticketId: $ticketId
      projectId: $projectId
      input: $worklogTimer
    ) {
      timerId
      serviceItem {
        itemId
        name
        quantityType
      }
      billable
      technician {
        userId
        name
        firstName
        lastName
      }
      state
      timespent
      timespentAfterHours
    }
  }
`;

const UPDATE_CURRENT_WORKLOG_TIMER = gql`
  mutation($timerId: ID!, $worklogTimer: WorklogTimerInput!) {
    updateWorklogTimer(timerId: $timerId, input: $worklogTimer) {
      timerId
      serviceItem {
        itemId
        name
        quantityType
      }
      billable
      technician {
        userId
        name
        firstName
        lastName
      }
      state
      timespent
      timespentAfterHours
    }
  }
`;

// const DELETE_WORKLOG_TIMER = gql``;

export {
  CREATE_NEW_WORKLOG,
  CREATE_NEW_WORKLOG_TIMER,
  UPDATE_CURRENT_WORKLOG_TIMER,
  UPDATE_WORKLOG
};
